module.exports = __webpack_public_path__ + "img/2-3.43fd3d84.svg";